import { deviceDetailSchema, deviceFilterOptionsResponseSchema, deviceIdSchema, deviceListResponseSchema, devicePostureSchema, deviceRevocationResponseSchema, linkDevicePersonResponseSchema, } from '../contracts/device-inventory';
import { organizationIdSchema, } from '../contracts/organizations';
import { serializeTableQueryParams, } from '../contracts/table';
import { userIdSchema } from '../contracts/user';
import { parseSchema } from '../errors';
/** One page of the Endpoints tab. */
export async function listOrganizationDevices(client, organizationId, params = {}, options) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const response = await client.get(`/organizations/${validatedId}/devices`, {
        params,
        paramsSerializer: serializeTableQueryParams,
        signal: options?.signal,
    });
    return parseSchema(deviceListResponseSchema, response);
}
/** Posture tiles over every device in the organization. */
export async function getOrganizationDevicePosture(client, organizationId) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const response = await client.get(`/organizations/${validatedId}/devices/posture`);
    return parseSchema(devicePostureSchema, response);
}
/** Distinct values for the OS / agent version filter dropdowns. */
export async function getOrganizationDeviceFilterOptions(client, organizationId, params) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const response = await client.get(`/organizations/${validatedId}/devices/filter-options`, { params });
    return parseSchema(deviceFilterOptionsResponseSchema, response);
}
/** The endpoint page of one device. */
export async function getOrganizationDevice(client, organizationId, deviceId) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const validatedDeviceId = parseSchema(deviceIdSchema, deviceId);
    const response = await client.get(`/organizations/${validatedId}/devices/${validatedDeviceId}`);
    return parseSchema(deviceDetailSchema, response);
}
/**
 * KIR-5413: link an Unattributed person seen on an endpoint to a member.
 * Owner or Manager; 404 while `shared_devices` is off.
 */
export async function linkOrganizationDevicePerson(client, organizationId, userId, body) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const validatedUserId = parseSchema(userIdSchema, userId);
    const response = await client.post(`/organizations/${validatedId}/devices/people/${validatedUserId}/link`, body);
    return parseSchema(linkDevicePersonResponseSchema, response);
}
/**
 * KIR-5658: revoke an enrolled device — its device key and every personal key
 * it issued stop working, and it cannot enroll again until reset. Owner or
 * Manager; 404 while `shared_devices` is off or the device is not enrolled.
 */
export async function revokeOrganizationDevice(client, organizationId, deviceId) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const validatedDeviceId = parseSchema(deviceIdSchema, deviceId);
    const response = await client.post(`/organizations/${validatedId}/devices/${validatedDeviceId}/revoke`);
    return parseSchema(deviceRevocationResponseSchema, response);
}
/** KIR-5658: clear a device's revoke so it can enroll again. Owner or Manager. */
export async function resetOrganizationDevice(client, organizationId, deviceId) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const validatedDeviceId = parseSchema(deviceIdSchema, deviceId);
    const response = await client.post(`/organizations/${validatedId}/devices/${validatedDeviceId}/reset`);
    return parseSchema(deviceRevocationResponseSchema, response);
}
//# sourceMappingURL=device-inventory.js.map